<span class="menu-icon" [ngClass]="icon">&nbsp;</span>
